var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-nav',{staticClass:"navbar-top navbar-dark",attrs:{"id":"navbar-main","show-toggle-button":false,"expand":""}},[_c('ul',{staticClass:"align-items-center navbar-nav d-none ml-md-auto d-md-flex"},[_c('language-dropdown',{staticClass:"nav-item dropdown mr-1"}),_vm._v(" "),_c('user-info-dropdown',{staticClass:"nav-item dropdown"})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e2044fa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/DashboardNavbar.vue
// module id = null
// module chunks = 